import { useState } from 'react';
/**Components */
import HeaderPage from '../../components/page/header';
import BodyPage from '../../components/page/body';
import ModalComponent from '../../components/modal';
/** Componentes propios */
import Filter from './filter';
import FormSupplier from './form';
/**Hooks */
import { useSuppliers } from '../../hooks';
/**Models */
import { SupplierRequest } from '../../models/requests';
/**Utilities */
import { SweetAlert } from '../../utilities';

/** Modal Resource */
interface DataModalState {
  type: string;
  buttonSubmit: string | null;
  row: any | null;
  title: string | null;
  requirements: any[];
  onCloseModalForm: () => void;
  errosBackend: any;
}

export const SupplierIndex = () => {
  const { fetchSuppliers, storeSupplier, updateSupplier, personSearch } = useSuppliers();
  const [dataModalResourceState, setDataModalResourceState] = useState<DataModalState>({
    type: '',
    buttonSubmit: null,
    row: null,
    title: null,
    requirements: [],
    onCloseModalForm: () => {},
    errosBackend: {},
  });
  const [errors, setErrors] = useState({});
  const [filterState, setFilterState] = useState({
    page: 1,
    type: '',
    text: '',
  });
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [stateModal, setStateModal] = useState<boolean>(false);

  //let errorsBakend = {};
  const state = {
    page: {
      title: 'Proveedores',
      icon: 'ri-user-star-line',
      model: 'suppliers',
      header: {
        menu: ['Proveedores'],
      },
      buttons: {
        create: true,
        edit: true,
        destroy: false,
        import: false,
        export: false,
      },
    },
    dataTable: {
      body: {
        widthAccion: "100px",
        cols: [
          {
            name: 'client_document_type_name',
            alias: 'Tipo de documento',
            width: '170px',
          },
          {
            name: 'document_number',
            alias: 'N° documento',
            width: '130px',
          },
          {
            name: 'names',
            alias: 'Proveedor',
          },
          {
            name: 'type_supplier',
            alias: 'Tipo de proveedor',
            width: '150px',
          },
          {
            name: 'state',
            alias: 'Estado',
            width: '60px',
            play: {
              type: 'states',
              values: {
                0: 'bg-danger-subtle text-danger',
                1: 'bg-success-subtle text-success',
              },
              names: {
                0: 'Inactivo',
                1: 'Activo',
              },
            },
          },
        ],
      },
    },
  };

  /** METODOS DEL FILTER */
  const onChangePage = (page: number, type: string) => {
    switch (type) {
      case 'prev':
        setFilterState({ ...filterState, page: filterState.page - 1 });
        fetchSuppliers(filterState.page - 1, filterState.text, filterState.type, true);
        break;

      case 'current':
        setFilterState({ ...filterState, page: page });
        fetchSuppliers(page, filterState.text, filterState.type, true);
        break;
      case 'next':
        setFilterState({ ...filterState, page: filterState.page + 1 });
        fetchSuppliers(filterState.page + 1, filterState.text, filterState.type, true);
        break;
      default:
        break;
    }
  };
  const onClearFilters = () => {
    setFilterState({ ...filterState, text: '', type: '' });
    fetchSuppliers(1, '', '', true);
  };

  const handleFilterChange = (newFilters: any) => {
    setFilterState(newFilters);
    fetchSuppliers(1, newFilters.text, newFilters.type, false);
  };

  /** METODOS DE MODAL */
  const onCloseModalForm = () => {
    setStateModal(false);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setErrors({});
  };

  const onClickAddResource = (type: string) => {
    setDataModalResourceState({
      type: type,
      buttonSubmit: 'Registrar',
      row: null,
      title: 'Nuevo proveedor',
      requirements: [],
      onCloseModalForm: onCloseModalForm,
      errosBackend: {},
    });
    setStateModal(true);
    setIsModalOpen(true);
  };

  const onClickDeleteResource = () => {};

  const onClickEditResource = (row: any) => {
    setDataModalResourceState({
      type: 'edit',
      buttonSubmit: 'Editar',
      row: {
        id: row.id,
        person: row
      },
      title: 'Editar proveedor',
      requirements: [],
      onCloseModalForm: onCloseModalForm,
      errosBackend: {},
    });
    setStateModal(true);
    setIsModalOpen(true);
  };

  /** METODOS DEL FORM RESOURCE */
  const onSubmitForm = async (supplierRequest: SupplierRequest, type: string) => {
    switch (type) {
      case 'store':
        storeSupplier(supplierRequest)
          .then(() => {
            onCloseModalForm();
            SweetAlert.success('Mensaje', 'Proveedor registrado correctamente.');
          })
          .catch((error) => {
            setErrors(error.response.data.errors);
          });
        break;
      case 'edit':
        updateSupplier(supplierRequest)
          .then(() => {
            onCloseModalForm();
            SweetAlert.success('Mensaje', 'Proveedor actualizada correctamente.');
          })
          .catch((error) => {
            setErrors(error.response?.data.errors);
          });
        break;
      default:
        break;
    }
  };

  const onClickButtonPersonalizado = () => {};

  return (
    <div className="main-body p-0">
      <div className="inner-wrapper">
        <div className="inner-main">
          <HeaderPage page={state.page} onModalResource={onClickAddResource} />
          <div className="inner-main-body">
            <div className="card card-featured card-featured-primary mb-3 mt-3">
              <div className="card-body">
                <Filter
                  onClearFilters={onClearFilters}
                  filterState={filterState}
                  onFilterChange={handleFilterChange}
                />
                <BodyPage onChangeDelete={onClickDeleteResource} onClickButtonPersonalizado={onClickButtonPersonalizado} onChangeEdit={onClickEditResource} onChangePage={onChangePage} page={state.page} table={state.dataTable} />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modal Resource */}
      {isModalOpen && (
        <ModalComponent
          stateModal={stateModal}
          typeModal={'static'}
          size={'modal-gg'}
          title={dataModalResourceState.title}
          content={<FormSupplier onSearchPerson={personSearch} errors={errors} data={dataModalResourceState} onSubmitForm={onSubmitForm} />}
          onClose={handleCloseModal}
        />
      )}
    </div>
  );
};

export default SupplierIndex;
